const t = {
  400: "font-normal",
  500: "font-medium",
  600: "font-semibold",
  700: "font-bold"
}, e = {
  36: "text-4xl",
  30: "text-3xl",
  24: "text-2xl",
  20: "text-xl",
  18: "text-lg",
  16: "text-base",
  14: "text-sm",
  12: "text-xs"
}, s = {
  44: "leading-11",
  38: "leading-9.5",
  32: "leading-8",
  30: "leading-7.5",
  28: "leading-7",
  24: "leading-6",
  20: "leading-5",
  16: "leading-4"
}, a = {
  2: "tracking-2"
  // 2px
}, n = {
  brand600: "text-brand-primary-600",
  link: "text-link-primary",
  primary: "text-text-primary",
  secondary: "text-text-secondary",
  tertiary: "text-text-tertiary",
  disabled: "text-text-disabled",
  help: "text-field-helper",
  label: "text-field-label",
  info: "text-support-info",
  success: "text-support-success",
  warning: "text-support-warning",
  error: "text-support-error",
  inverse: "text-text-on-color"
};
export {
  n as fontColorClassNames,
  e as fontSizeClassNames,
  t as fontWeightClassNames,
  a as letterSpacingClassNames,
  s as lineHeightClassNames
};
//# sourceMappingURL=styles.es.js.map
